import { ref, computed } from 'vue'
import { API_URL } from '../config'

const adminToken = ref(localStorage.getItem('adminToken') || null)
const adminUser = ref(localStorage.getItem('adminUser') || null)

export function useAuth() {
  const isAdminLoggedIn = computed(() => !!adminToken.value)

  const loginAdmin = async (usuario, password) => {
    const response = await fetch(`${API_URL}?url=admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ usuario, password })
    })

    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.message || 'Error en autenticación')
    }

    adminToken.value = result.data.token
    adminUser.value = result.data.usuario

    // Guardar en localStorage
    localStorage.setItem('adminToken', result.data.token)
    localStorage.setItem('adminUser', result.data.usuario)

    return result.data
  }

  const logoutAdmin = () => {
    adminToken.value = null
    adminUser.value = null
    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminUser')
  }

  return {
    adminToken,
    adminUser,
    isAdminLoggedIn,
    loginAdmin,
    logoutAdmin
  }
}
